import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient/configuracao/revisoes/modelo-documento-revisao/ModeloDocumentoRevisaoApiClient'

export default {
	async [actionTypes.CONFIGURACAO.REVISOES.MODELO_DOCUMENTO.SALVAR_MODELO_DOCUMENTO_REVISAO](
		context,
		{ idRevisao, body },
	) {
		const { data } = await api.salvarModeloDocumentoRevisao(idRevisao, body)
		return data
	},

	async [actionTypes.CONFIGURACAO.REVISOES.MODELO_DOCUMENTO.REMOVER_MODELO_DOCUMENTO_REVISAO](context, idRevisao) {
		await api.removerModeloDocumentoRevisao(idRevisao)
	},

	async [actionTypes.CONFIGURACAO.REVISOES.MODELO_DOCUMENTO.REDIGIR_MODELO_DOCUMENTO_REVISAO](context, idRevisao) {
		const { data } = await api.redigirModeloDocumentoRevisao(idRevisao)
		return data
	},

	async [actionTypes.CONFIGURACAO.REVISOES.MODELO_DOCUMENTO.VISUALIZAR_MODELO_DOCUMENTO_REVISAO](context, idRevisao) {
		const { data } = await api.visualizarModeloDocumentoRevisao(idRevisao)
		return data
	},
}
